import React from 'react';
import createSvgIcon from '@one-thd/sui-atomic-components/dist/utils/createSvgIcon';

export const SparkleIcon = createSvgIcon(<>
  <path
    d="M14.22,18.79c-1.17-8.04-7.53-8.92-9.22-9.21,1.69-.28,8.05-1.16,9.22-9.21,1.17,8.04,7.53,8.92,9.22,9.21-1.69.28-8.05,1.16-9.22,9.21Z"
  />
  <path
    d="M20.71,6.17c-.35-2.38-2.23-2.64-2.73-2.73.5-.08,2.39-.34,2.73-2.73.35,2.38,2.23,2.64,2.73,2.73-.5.08-2.39.34-2.73,2.73Z"
  />
  <path
    d="M4.3,20.01c-.5-3.42-3.21-3.8-3.93-3.92.72-.12,3.43-.5,3.93-3.92.5,3.42,3.21,3.8,3.93,3.92-.72.12-3.43.5-3.93,3.92Z"
  />
  <path
    d="M10.14,20.79c-.24-1.66-1.56-1.84-1.9-1.9.35-.06,1.66-.24,1.9-1.9.24,1.66,1.56,1.84,1.9,1.9-.35.06-1.66.24-1.9,1.9Z"
  />
</>, "Sparkle");


